<template>
  <details-sheet :item="device" :headers="headers" v-bind="$attrs">
    <template v-slot:item.date_registration="{ item }">
      {{ item.date_registration | dateFormat }}
    </template>
  </details-sheet>
</template>

<script>
import { dateFormat } from '@/modules/_global/filters';
import DetailsSheet from '@/modules/_global/_components/DetailsSheet.vue';

export default {
  name: 'DeviceDetails',

  filters: {
    dateFormat
  },

  components: {
    DetailsSheet
  },

  props: {
    device: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          value: 'id'
        },
        {
          text: this.$t('DEVICES.DATE_OF_REGISTRATION'),
          value: 'date_registration'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type.name'
        }
      ];
    }
  }
};
</script>
